import React from 'react';
import styles from './RelatedButtons.module.scss';
import RelatedSwitch from '../RelatedSwitch/RelatedSwitch';
import { useVisiblePreview } from '../DocFormProvider';

const RelatedButtons = ({
  handleChangePreview,
  visibleRelatedObjects,
  handleRelatedObjects,
  showRelatedFilesSwitch,
  showRelatedObjectsSwitch,
}) => {
  const { visible } = useVisiblePreview() || {};

  return (
    <div className={styles.root}>
      {showRelatedFilesSwitch && (
        <RelatedSwitch
          label="Предпросмотр"
          onChange={handleChangePreview}
          checked={visible}
        />
      )}
      {showRelatedObjectsSwitch && (
        <RelatedSwitch
          label="Показывать связанные объекты"
          onChange={handleRelatedObjects}
          checked={visibleRelatedObjects}
        />
      )}
    </div>
  );
};

export default RelatedButtons;
